import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Box,
  Drawer,
  ListItemButton,
  List,
  ListItemIcon,
  ListItem,
  Button,
  Divider,
  ListItemText,
  CssBaseline,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import Logout from "../asset/logout.png";
import {
  Home,
  Assessment,
  AccountCircle,
  Summarize,
  RequestQuote,
} from "@mui/icons-material";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { deleteClientData, deleteGateWayData } from "../redux/actions/index";
import logo from "../asset/icon.png";
import Zodhya from "../asset/zodhya.png";
import { signOut } from "aws-amplify/auth";

const Navbar = (props) => {
  const { window, mobileOpen, handleDrawerToggle } = props;
  //const [_anchorEl, setAnchorEl] = React.useState(null);
  let dispatch = useDispatch();

  // const handleMenu = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };

  // const handleClose = () => {
  //   setAnchorEl(null);
  // };

  //const drawerWidth = 285;

  const container =
    window !== undefined ? () => window().document.body : undefined;

  const { pathname } = useLocation();
  let navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(); // Amplify clears all tokens internally
    } catch (e) {
      console.error("Logout error:", e);
    }
    localStorage.removeItem("orgID");
    localStorage.removeItem("userData");
    dispatch({ type: "LOGOUT" });
    navigate("/");
    dispatch(deleteClientData());
    dispatch(deleteGateWayData());
    setDialogOpen(false);
  };

  const drawer = (
    <>
      <Box
        sx={{ textAlign: "center" }}
        className="mt-9 mb-12"
      >
        <Link to={"/"} onClick={handleDrawerToggle}>
          <img
            src={logo}
            alt="zodhya-logo"
            className="h-7 inline-block mb-1"
          />
          <img src={Zodhya} alt="zodhya" width={90} className="mx-auto" />
        </Link>
      </Box>
      <Box className="flex flex-col justify-between h-[100vh]">
        <List style={{ justifyContent: "center" }}>
          {[
            {
              name: "Gateways",
              icon: <Home sx={{ color: "#C5C5C5" }} />,
              iconActive: <Home sx={{ color: "#298F9D" }} />,
              to: "/",
            },
            {
              name: "Analytics",
              icon: <Assessment sx={{ color: "#C5C5C5" }} />,
              iconActive: <Assessment sx={{ color: "#298F9D" }} />,
              to: "/analytics",
            },
            {
              name: "Reports",
              icon: <Summarize sx={{ color: "#C5C5C5" }} />,
              iconActive: <Summarize sx={{ color: "#298F9D" }} />,
              to: "/reports",
            },
            {
              name: "Bills",
              icon: <RequestQuote sx={{ color: "#C5C5C5" }} />,
              iconActive: <RequestQuote sx={{ color: "#298F9D" }} />,
              to: "/bill",
            },
          ].map((text, index) => (
            <ListItem
              key={text.name}
              disablePadding
              sx={{
                backgroundColor: text.to === pathname ? "#EDEDED" : "",
              }}
            >
              <ListItemButton
                component={Link}
                to={text.to}
                onClick={handleDrawerToggle}
              >
                <Box
                  className="flex items-center justify-center"
                  style={{ color: "#818181" }}
                  sx={{ ml: { xs: 2, sm: 2, lg: 7 } }}
                >
                  <ListItemIcon>
                    {text.to === pathname ? text.iconActive : text.icon}
                  </ListItemIcon>
                  <ListItemText
                    primary={text.name}
                    sx={{ color: text.to === pathname ? "#298F9D" : "" }}
                  />
                </Box>
              </ListItemButton>
            </ListItem>
          ))}
        </List>

        <Box className="mb-12">
          <Divider />
          <List>
            {[
              {
                name: "Account",
                icon: <AccountCircle sx={{ color: "#C5C5C5" }} />,
                iconActive: <AccountCircle sx={{ color: "#298F9D" }} />,
                to: "/profile",
              },
            ].map((text, index) => (
              <ListItem
                onClick={handleDrawerToggle}
                key={text.name}
                disablePadding
                sx={{
                  display: "block",
                  backgroundColor: text.to === pathname ? "#EDEDED" : "",
                }}
              >
                <ListItemButton component={Link} to={text.to}>
                  <Box
                    className="flex items-center justify-center"
                    style={{ color: "#818181" }}
                    sx={{ ml: { xs: 2, sm: 2, lg: 7 } }}
                  >
                    <ListItemIcon>
                      {text.to === pathname ? text.iconActive : text.icon}
                    </ListItemIcon>
                    <ListItemText
                      primary={text.name}
                      sx={{ color: text.to === pathname ? "#298F9D" : "" }}
                    />
                  </Box>
                </ListItemButton>
              </ListItem>
            ))}

            <ListItem
              key={"Logout"}
              disablePadding
              sx={{ display: "block" }}
            >
              <ListItemButton
                onClick={() => {
                  setDialogOpen(true);
                }}
              >
                <Box
                  className="flex items-center justify-center"
                  style={{ color: "#818181" }}
                  sx={{ ml: { xs: 2, sm: 2, lg: 7 } }}
                >
                  <ListItemIcon>
                    <img
                      src={Logout}
                      alt="logout"
                      className="h-[20px] pl-[3px]"
                    />
                  </ListItemIcon>
                  <ListItemText primary={"Logout"} />
                </Box>
              </ListItemButton>
            </ListItem>
          </List>
        </Box>
      </Box>
    </>
  );

  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <Box
          component="nav"
          sx={{
            width: { md: "220px", lg: "285px", sm: "220px" },
            flexShrink: { sm: 0 },
          }}
          aria-label="mailbox folders"
        >
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              display: { xs: "block", sm: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: { md: "220px", lg: "285px", sm: "220px", xs: "220px" },
              },
              position: "relative",
            }}
          >
            {drawer}
          </Drawer>
          <Drawer
            variant="permanent"
            sx={{
              display: { xs: "none", sm: "block" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: { md: "220px", lg: "285px", sm: "220px", xs: "220px" },
              },
              position: "relative",
            }}
            open
          >
            {drawer}
          </Drawer>
        </Box>
      </Box>

      <div>
        <Dialog
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to logout?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#F97316",
                ":hover": { backgroundColor: "#F97316" },
              }}
              onClick={() => setDialogOpen(false)}
            >
              Cancel
            </Button>
            <Button
              variant="outlined"
              color="error"
              onClick={handleLogout}
              autoFocus
            >
              Logout
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default Navbar;
